import AccessTime from "@material-ui/icons/AccessTime";
import Add from "@material-ui/icons/Add";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";
import Build from "@material-ui/icons/Build";
import BuildOutlined from "@material-ui/icons/BuildOutlined";
import Check from "@material-ui/icons/Check";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Close from "@material-ui/icons/Close";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import DescriptionOutlined from "@material-ui/icons/DescriptionOutlined";
import DirectionsCar from "@material-ui/icons/DirectionsCar";
import DriveEta from "@material-ui/icons/DriveEta";
import Edit from "@material-ui/icons/Edit";
import EditOutlined from "@material-ui/icons/EditOutlined";
import ErrorFilled from "@material-ui/icons/Error";
import Event from "@material-ui/icons/Event";
import ExpandMore from "@material-ui/icons/ExpandMore";
import FileCopyOutlined from "@material-ui/icons/FileCopyOutlined";
import ListAlt from "@material-ui/icons/ListAlt";
import LocalParking from "@material-ui/icons/LocalParking";
import LocalShipping from "@material-ui/icons/LocalShipping";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import PhotoLibrary from "@material-ui/icons/PhotoLibrary";
import Receipt from "@material-ui/icons/Receipt";
import Refresh from "@material-ui/icons/Refresh";
import ReportProblem from "@material-ui/icons/ReportProblem";
import Speed from "@material-ui/icons/Speed";
import Storefront from "@material-ui/icons/Storefront";
import StraightenOutlined from "@material-ui/icons/StraightenOutlined";
import UnfoldLess from "@material-ui/icons/UnfoldLess";
import UnfoldMore from "@material-ui/icons/UnfoldMore";
import ViewList from "@material-ui/icons/ViewList";
import Warning from "@material-ui/icons/Warning";
import { faCarBattery } from "@fortawesome/free-solid-svg-icons/faCarBattery";
import { faCarSide } from "@fortawesome/free-solid-svg-icons/faCarSide";
import { faCompactDisc } from "@fortawesome/free-solid-svg-icons/faCompactDisc";
import { faOilCan } from "@fortawesome/free-solid-svg-icons/faOilCan";
import { faWrench } from "@fortawesome/free-solid-svg-icons/faWrench";
import { faSvgIcon } from "./faSvgIcon.utils";
import type { IconComponent } from "./iconProps.utils";

// Named for what they mean in the app, so the drawing behind each can change in one place.
export const AddIcon: IconComponent = Add;
export const BackIcon: IconComponent = ArrowBackIos;
export const PullDownIcon: IconComponent = ArrowDownward;
export const CalendarIcon: IconComponent = Event;
export const CameraIcon: IconComponent = PhotoCamera;
export const CarIcon: IconComponent = DirectionsCar;
export const CheckCircleIcon: IconComponent = CheckCircle;
export const CheckIcon: IconComponent = Check;
export const ClockIcon: IconComponent = AccessTime;
export const CloseIcon: IconComponent = Close;
export const CollapseAllIcon: IconComponent = UnfoldLess;
export const CopyIcon: IconComponent = FileCopyOutlined;
export const DeleteIcon: IconComponent = DeleteOutline;
export const DetailsIcon: IconComponent = ListAlt;
export const DocumentIcon: IconComponent = DescriptionOutlined;
export const EditIcon: IconComponent = Edit;
export const EditOutlinedIcon: IconComponent = EditOutlined;
export const ErrorIcon: IconComponent = ErrorFilled;
export const ExpandAllIcon: IconComponent = UnfoldMore;
export const ExpandIcon: IconComponent = ExpandMore;
export const ForwardIcon: IconComponent = ArrowForwardIos;
export const GalleryIcon: IconComponent = PhotoLibrary;
export const ListIcon: IconComponent = ViewList;
export const ParkingIcon: IconComponent = LocalParking;
export const ReceiptIcon: IconComponent = Receipt;
export const RefreshIcon: IconComponent = Refresh;
export const ReportIssueIcon: IconComponent = ReportProblem;
export const RulerIcon: IconComponent = StraightenOutlined;
export const ServiceIcon: IconComponent = Build;
export const ServiceOutlinedIcon: IconComponent = BuildOutlined;
export const SpeedometerIcon: IconComponent = Speed;
export const StoreIcon: IconComponent = Storefront;
export const TruckIcon: IconComponent = LocalShipping;
export const VehicleIcon: IconComponent = DriveEta;
export const WarningIcon: IconComponent = Warning;

// Material has no drawing for these, so they come from FontAwesome in the same box.
export const BrakeDiscIcon = faSvgIcon(faCompactDisc, "BrakeDiscIcon");
export const CarBatteryIcon = faSvgIcon(faCarBattery, "CarBatteryIcon");
export const CarSideIcon = faSvgIcon(faCarSide, "CarSideIcon");
export const OilCanIcon = faSvgIcon(faOilCan, "OilCanIcon");
export const WrenchIcon = faSvgIcon(faWrench, "WrenchIcon");
